import { render } from "./App.vue?vue&type=template&id=68c7aae4&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=68c7aae4&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c7aae4"]])

export default __exports__